export default __webpack_public_path__ + "img/d213680689e4b8add93849ba2a10e6c9.svg";